import React, { useEffect, useState } from "react";
import ProfileService from "../../../../services/ProfileService/ProfileService";
import Modal from "../../../../components/Modal/Modal";
import { useTranslation } from "react-i18next";
import './styles.css';
const ActioneerResultDetail = (props) => {
  const { openDetail, setOpen } = props;
  const label = "CONTENT.ALERT.";
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const { actioneer_profile_name, alert_profile_name, error_message, result } = data;

  useEffect(() => {
    const fetchData = async () => {
      const res = await ProfileService.getByActioneerResult(openDetail?.id);
      if (res?.data) {
        setData(res.data);
      }
    };
    fetchData().then((r) => r);
  }, []);
  return (
    <Modal setOpen={setOpen} minWidth={875}>
      <table className="actiooner-table">
        <tr>
          <th>{t(label + "ACTIOONER-PROFILE-NAME")}</th>
          <th>{t(label + "ALERT-PROFILE-NAME")}</th>
          <th>{t(label + "ERROR-MESSAGE")}</th>
          <th>{t(label + "RESULT")}</th>
        </tr>
        <tr>
          <td>{actioneer_profile_name}</td>
          <td>{alert_profile_name}</td>
          <td>{error_message}</td>
          <td>{result}</td>
        </tr>
      </table>
    </Modal>
  );
};

export default ActioneerResultDetail;
